export const diff = (a: string[], b: string[]) => {
    return {
        remove: a.filter((x) => !b.includes(x)),
        add: b.filter((x) => !a.includes(x)),
        overlap: a.filter((x) => b.includes(x)),
    };
};
